import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { deliveryLabel, settlementLabel } from "@/lib/orderLabels";

export default function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div style={{ padding: 40, color: "var(--ink-mute)" }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app/dashboard" replace />;
  return children;
}

/**
 * Role-aware status pill.
 * `scope` ∈ "delivery" | "settlement" picks the label dictionary.
 * `role`  ∈ "buyer" | "supplier" | "admin" — admin gets neutral wording.
 * Falls back to the legacy "underscore-replaced raw status" if no scope/role.
 */
export function StatusPill({ status, role, scope = "delivery" }) {
  if (!status) return null;
  const cls = `pill pill-${status}`;
  let label;
  if (scope === "settlement") label = settlementLabel(status, role);
  else if (scope === "delivery") label = deliveryLabel(status, role);
  else label = String(status).replace(/_/g, " ");
  return <span className={cls} data-testid={`status-${status}`}>{label}</span>;
}

export function KpiCard({ label, value, sub, accent }) {
  return (
    <div className="card" style={{ padding: 20 }} data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div style={{ fontSize: 11, color: "var(--ink-mute)", textTransform: "uppercase", letterSpacing: ".08em", fontWeight: 600 }}>{label}</div>
      <div className="font-serif-display" style={{ fontSize: 34, color: accent || "var(--ink)", marginTop: 8, fontWeight: 600 }}>{value}</div>
      {sub && <div className="font-mono" style={{ fontSize: 11, color: "var(--ink-mute)", marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 24, flexWrap: "wrap", gap: 16 }}>
      <div>
        <h1 className="font-serif-display" style={{ fontSize: 30, fontWeight: 600, margin: 0, color: "var(--ink)" }}>{title}</h1>
        {subtitle && <div style={{ fontSize: 14, color: "var(--ink-dim)", marginTop: 6, maxWidth: 640 }}>{subtitle}</div>}
      </div>
      {actions}
    </div>
  );
}
